import { z } from 'zod';

/////////////////////////////////////////
// PICK LIST SCHEMA
/////////////////////////////////////////

export const PickListSchema = z.object({
  pickId: z.number().int(),
  cityId: z.number().int(),
  pickName: z.string(),
  pickValue: z.string(),
  pickOrder: z.number().int(),
})

export type PickList = z.infer<typeof PickListSchema>

export default PickListSchema;
